import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import moment from 'moment';
import ics from 'ics';
import * as icons from '../Icons/Icons';

const AddToCalendar = observer(class AddToCalendar extends React.Component {
  render() {
    const { title, start, duration, location, lat, lon, translation } = this.props;
    const startISO = moment(start, 'M-D-YYYY HH:mm Z').toISOString().replace(/-|:|\.\d\d\d/g,'');
    const endISO = moment(start, 'M-D-YYYY HH:mm Z').add(duration, 'minutes').toISOString().replace(/-|:|\.\d\d\d/g,'');
    let focus = false;

    // Generate ICS file data
    const newICS = new ics();

    const calDownload = newICS.buildEvent({
      start: moment(start).format('YYYY-MM-DD HH:mm'),
      end: moment(start).add(duration, 'minutes').format('YYYY-MM-DD HH:mm'),
      title: title,
      location: location,
      geo: {
        lat: lat,
        lon: lon
      }
    });

    // Generate Google Calendar link
    const calGoogle = `https://calendar.google.com/calendar/render?action=TEMPLATE&dates=${startISO}/${endISO}&location=${location}&text=${title}`

    // Generate Outlook.com link
    const calOutlook = `https://outlook.live.com/owa/?rru=addevent&startdt=${startISO}&enddt=${endISO}&subject=${title}&location=${location}&allday=false&path=/calendar/view/Month`;

    // Generate Yahoo Calendar link
    const calYahoo = `https://calendar.yahoo.com/?v=60&view=d&type=20&title=${title}&st=${startISO}&dur=${duration}&desc=&in_loc=${location}`;

    // Accessibility
    function blurDropdown() {
      if(focus) {
        document.querySelector('.faux-select:focus').blur();
      }

      focus = !focus;
    }

    function focusButton(e) {
      let el = e.target.parentElement;

      while(el) {
        if(el.className.indexOf('dropdown') > -1) {
          el.className += ' dropdown--active';
          return el;
        } else {
          el = el.parentElement;
        }
      }
    }

    function blurButton(e) {
      let el = e.target.parentElement;

      while(el) {
        if(el.className.indexOf('dropdown') > -1) {
          el.className = el.className.replace('dropdown--active', '');
          return el;
        } else {
          el = el.parentElement;
        }
      }
    }

    // Return the menu
    return (
      <div className="faux-select calendar-add" tabIndex="0">
        <Dropdown ref="fauxSelect">
          <DropdownTrigger className="faux-select__selected" onClick={blurDropdown}>
            {translation.label}
          </DropdownTrigger>

          <DropdownContent>
            <ul className="faux-select__options dropdown__menu">
              <li>
                <a
                  className="faux-select__btn"
                  href={`data:text/calendar,${encodeURI(calDownload)}`}
                  onFocus={(e) => {focusButton(e)}}
                  onBlur={(e) => {blurButton(e)}}
                >
                  <icons.iconApple />
                  {translation.apple}
                </a>
              </li>
              <li>
                <a
                  className="faux-select__btn"
                  target="_blank"
                  href={calGoogle}
                  onFocus={(e) => {focusButton(e)}}
                  onBlur={(e) => {blurButton(e)}}
                >
                  <icons.iconGoogle />
                  {translation.google}
                </a>
              </li>
              <li>
                <a
                  className="faux-select__btn"
                  href={`data:text/calendar,${encodeURI(calDownload)}`}
                  onFocus={(e) => {focusButton(e)}}
                  onBlur={(e) => {blurButton(e)}}
                >
                  <icons.iconMicrosoft />
                  {translation.outlook}
                </a>
              </li>
              <li>
                <a
                  className="faux-select__btn"
                  target="_blank"
                  href={calOutlook}
                  onFocus={(e) => {focusButton(e)}}
                  onBlur={(e) => {blurButton(e)}}
                >
                  <icons.iconMicrosoft />
                  {translation.outlook_web}
                </a>
              </li>
              <li>
                <a
                  className="faux-select__btn"
                  target="_blank"
                  href={calYahoo}
                  onFocus={(e) => {focusButton(e)}}
                  onBlur={(e) => {blurButton(e)}}
                >
                  <icons.iconYahoo />
                  {translation.yahoo}
                </a>
              </li>
            </ul>
          </DropdownContent>
        </Dropdown>
      </div>
    )
  }
})

export default translate('AddToCalendar')(AddToCalendar);



// WEBPACK FOOTER //
// ./src/app/components/Calendar/AddToCalendar.js